import { ContainerTabsProvider } from './ContainerTabsContext'
import type { ContainerTabsProps } from './types'
import styles from './ContainerTabs.module.css'

/**
 * Componente principal de abas dentro de containers.
 * Provê o contexto para os componentes filhos (ContainerTabsList, ContainerTab, ContainerTabPanel).
 */
export function ContainerTabs({
  children,
  defaultTab,
  value,
  onChange,
  className,
  id,
}: ContainerTabsProps) {
  return (
    <ContainerTabsProvider
      defaultTab={defaultTab}
      value={value}
      onChange={onChange}
      id={id}
    >
      <div className={[styles.containerTabs, className].filter(Boolean).join(' ')}>
        {children}
      </div>
    </ContainerTabsProvider>
  )
}
